import { forwardRef, type ComponentPropsWithoutRef } from 'react'
import * as RxRadio from '@radix-ui/react-radio-group'
import { cn } from './cn'

export type RadioGroupProps = Omit<
  ComponentPropsWithoutRef<typeof RxRadio.Root>,
  'asChild'
>

export const RadioGroup = forwardRef<HTMLDivElement, RadioGroupProps>(
  ({ className, ...rest }, ref) => (
    <RxRadio.Root ref={ref} className={cn('radio-group', className)} {...rest} />
  ),
)
RadioGroup.displayName = 'RadioGroup'

export type RadioGroupItemProps = Omit<
  ComponentPropsWithoutRef<typeof RxRadio.Item>,
  'asChild'
>

export const RadioGroupItem = forwardRef<HTMLButtonElement, RadioGroupItemProps>(
  ({ className, ...rest }, ref) => (
    <RxRadio.Item ref={ref} className={cn('radio-item', className)} {...rest}>
      <RxRadio.Indicator className="radio-indicator" />
    </RxRadio.Item>
  ),
)
RadioGroupItem.displayName = 'RadioGroupItem'
